// How a person is named in the sharing and ownership dialogs.
export const nameOf = (u) => u?.displayName || u?.display_name || u?.email || '—';
